/**
 * Matching the default in frontlib-gui:
 * https://github.com/FigureTechnologies/frontlib-gui/blob/master/src/Layout/TwoColumn/TwoColumnMainContent.js#L85
 */
export const DEFAULT_WIDTH = 564;

export const OFFER_SELECT = 708;
